import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConnectedHistoryComponent from './ConnectedHistoryComponent';
import { getModel } from './selectors';
import * as actions from './actions';

const ConnectedHistoryContainer = (props) => {
    return <ConnectedHistoryComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const ConnectedHistoryContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectedHistoryContainer);

export default React.memo(ConnectedHistoryContainerConn);

